import { post } from 'jquery';
import * as types from './types';

const initialState = {
  getOvernightCampEnrollment: {},
  postOvernightCampEnrollment: {},
  getOvernightCampParticipantsList: {},
  postOvernightCampParticipantsList: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };

    case types.YUSA_OVERNIGHT_CAMP_GET_ENROLLMENT_AND_OCCUPANCY_SUCCESS:
      return {
        ...state,
        getOvernightCampEnrollment: action.payload
      };
    case types.YUSA_OVERNIGHT_CAMP_GET_ENROLLMENT_AND_OCCUPANCY_FAILURE:
      return { ...state, error: action.payload };

    case types.YUSA_OVERNIGHT_CAMP_POST_ENROLLMENT_AND_OCCUPANCY_SUCCESS:
      return {
        ...state,
        postOvernightCampEnrollment: action.payload
      };
    case types.YUSA_OVERNIGHT_CAMP_POST_ENROLLMENT_AND_OCCUPANCY_FAILURE:
      return { ...state, error: action.payload };

    case types.YUSA_OVERNIGHT_CAMP_GET_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        getOvernightCampParticipantsList: action.payload
      };
    case types.YUSA_OVERNIGHT_CAMP_GET_PARTICIPANTS_FAILURE:
      return { ...state, error: action.payload };

    case types.YUSA_OVERNIGHT_CAMP_POST_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        postOvernightCampParticipantsList: action.payload
      };
    case types.YUSA_OVERNIGHT_CAMP_POST_PARTICIPANTS_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
